// Init Sentry
import onUserHasConsentedToCookies from "./onUserHasConsentedToCookies";
import * as Sentry from "@sentry/browser";
import {BrowserTracing} from "@sentry/tracing";
const isNeosBackend = document.body.classList.contains('neos-backend');
const isDevelopment = location.href.indexOf('neoswebsite.ddev.site') === -1;
if(!isNeosBackend && !isDevelopment) {
	onUserHasConsentedToCookies('statistics', () => {
		Sentry.init({
			dsn: "https://cda2bcefccf74f589cac99d81208b271@o336756.ingest.sentry.io/6759128",
			integrations: [new BrowserTracing()],

			// Set tracesSampleRate to 1.0 to capture 100%
			// of transactions for performance monitoring.
			// We recommend adjusting this value in production
			tracesSampleRate: 1.0,
		});
	});
}

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== "function") {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch(e => setTimeout(() => { throw e; }));
    };
}

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';

window.Alpine = Alpine;
Alpine.plugin(focus);

import './Presentation/Atom/IconTooltip/IconTooltip.js';
import './Presentation/Atom/RichText/RichText.js';
import './Presentation/Organism/Header/Header.SearchModal.js';
import "./Presentation/Organism/LettersList/LettersList";
import './scripts/scrollable.js';
import Fixed from './scripts/fixed.js';

Alpine.start();

import 'share-api-polyfill';
import 'lazysizes';

// other distribution packages
import '../../../../CodeQ.ContentAggregator/Resources/Private/Fusion/Root.js';
import '../../../../CodeQ.Likes/Resources/Private/Fusion/Root.js';
import '../../../../CodeQ.UserGeneratedImages/Resources/Private/Fusion/Root.js';
import GoogleRecaptcha from "../../../../CodeQ.RecaptchaAuth/Resources/Private/Fusion/Root";
import "../../../../CodeQ.Shortcuts/Resources/Private/Fusion/Integration/Organism/ShortcutCreationForm/ShortcutCreationForm";
import "../../../../CodeQ.CamBuildr/NodeTypes/Mixin/Form/Form";


import HeroImage from "./Presentation/Organism/HeroImage/HeroImage";
import ShareButton from "./Presentation/Atom/ShareButton/ShareButton";
import TopicSlider from "./Presentation/Molecule/TopicSlider/TopicSlider";
import StorySlider from "./Presentation/Molecule/StorySlider/StorySlider";
import NewsTeaser from "./Presentation/Molecule/NewsTeaser/NewsTeaser";
import CardGrid from "./Presentation/Molecule/CardGrid/CardGrid";
import HubspotForm from "./Presentation/Molecule/HubspotForm/HubspotForm.js";
import MultiSurvey from "./Presentation/Molecule/MultiSurvey/MultiSurvey.js";
import YoutubePlayer from "./Presentation/Molecule/YouTubePlayer/YouTubePlayer";
import SocialIconsListShareButtons from "./Presentation/Molecule/SocialIconsList/SocialIconsList.ShareButtons";
import HashMenu from "./Presentation/Molecule/HashMenu/HashMenu";
import EventCountdown from "./Presentation/Organism/EventCountdown/EventCountdown";
import GoogleMap from "./Presentation/Organism/GoogleMap/GoogleMap";
import General from "./javascript/general";
import YoutubeSlider from "./Presentation/Organism/YoutubeSlider/YoutubeSlider";
import NotificationBar from "./Presentation/Organism/NotificationBar/NotificationBar";

// Alpine definitions
import "./Presentation/Molecule/ImageSlider/ImageSlider";
import HeroVideo from "./Presentation/Organism/HeroVideo/HeroVideo";

class App {
    constructor() {
		General.init();
		GoogleRecaptcha.init();

		HeroImage.init();
        HeroVideo.init();
        ShareButton.init();
		TopicSlider.init();
        StorySlider.init();
        NewsTeaser.init();
        CardGrid.init();
        HubspotForm.init();
        MultiSurvey.init();
        YoutubePlayer.init();
        YoutubeSlider.init();
        SocialIconsListShareButtons.init();
        HashMenu.init();
		GoogleMap.init();
        Fixed.init();
        EventCountdown.init();
		NotificationBar.init()
    }

    get() {
        return this;
    }
}

window.app = new App();
